// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
  size: letter portrait;
  margin: 0.25in;
}
:host {
  display: block;
  background: white;
  min-height: 100vh;
}

.pdf-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 52px;
  padding: 8px 16px;
  border-bottom: 1px solid #d6d6d6;
  background: #f7f7f7;
}

.pdf-actions {
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}

.pdf-preview {
  display: block;
  width: 100%;
  height: calc(100vh - 53px);
  border: 0;
  background: #525659;
}

.container.report {
  box-sizing: border-box;
  width: 8in;
  max-width: 8in;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  font-family: sans-serif;
  font-size: 10.5pt;
}

.title {
  font-weight: bold;
  text-decoration: underline;
}

.caption-bold {
  font-weight: bold;
}

.cell {
  height: 1.5em;
  overflow: hidden;
}
.cell.value {
  text-align: center;
  border-bottom: 1px solid black;
}

.row > .reading-label {
  text-align: right;
  padding-right: 6px;
}

.new-section {
  margin-top: 10px;
}

.dark-pale {
  background-color: #feffa4 !important;
}

.divider {
  background-color: #cccccc !important;
}

.nobr {
  white-space: nowrap;
}

.width20 {
  width: 20px;
}

.width100px {
  width: 100px;
}

.width155 {
  width: 155px;
}

.width160px {
  width: 160px;
}

.width200px {
  width: 200px;
}

.width730px {
  width: 730px;
}

table.wide {
  width: 730px;
}

table.printable {
  font-size: 10.5pt;
  border-spacing: 0;
  border-style: solid;
  border-color: black;
  border-collapse: collapse;
  margin: 3px 0;
  page-break-inside: avoid;
}
table.printable th, table.printable td {
  border-width: 1px;
  padding: 0 3px;
  border-style: solid;
  border-color: black;
  page-break-inside: avoid;
}
table.printable th.text-center {
  text-align: center;
}

table.content-top td {
  vertical-align: top;
}

table.worksheet-tables table.printable tr > :nth-child(2):not([colspan]) {
  min-width: 150px;
}

table.worksheet-tables table.naf-tests {
  margin-top: 20px;
}

table caption {
  padding: 0;
}

table caption:empty {
  display: none;
}

div.pagebreak {
  page-break-after: always;
  page-break-inside: avoid;
}

hr.hiddenprint {
  margin: 8px 0;
  border-top: 1px dashed #ccc;
}

@media print {
  :host {
    background: white;
  }
  .container.report {
    max-width: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .no-print {
    display: none !important;
  }
  .hiddenprint {
    display: none !important;
  }
  .dark-pale {
    background-color: #feffa4 !important;
  }
  * {
    font-size: 7pt;
  }
  h4, h5 {
    font-size: 1rem;
  }
}
@media (max-width: 720px) {
  .pdf-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .pdf-preview {
    height: calc(100vh - 105px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/worksheet-print/worksheet-print.component.scss"],"names":[],"mappings":"AAGA;EACE,qBAAA;EACA,cAAA;AAFF;AAKA;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,cAAA;EACA,QAAA;AAHF;;AAMA;EACE,cAAA;EACA,WAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AAHF;;AAMA;EACE,sBAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,0BAAA;AAHF;;AAMA;EACE,iBAAA;AAHF;;AAMA;EACE,aAAA;EACA,gBAAA;AAHF;AAKE;EACE,kBAAA;EACA,8BAAA;AAHJ;;AAOA;EACE,iBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,oCAAA;AAJF;;AAOA;EACE,oCAAA;AAJF;;AAOA;EAAQ,mBAAA;AAHR;;AAKA;EAAc,WAAA;AADd;;AAEA;EAAc,YAAA;AAEd;;AADA;EAAc,YAAA;AAKd;;AAJA;EAAc,YAAA;AAQd;;AAPA;EAAc,YAAA;AAWd;;AAVA;EAAc,YAAA;AAcd;;AAZA;EAAa,YAAA;AAgBb;;AAdA;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,wBAAA;AAiBF;AAfE;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;AAiBJ;AAdE;EAAiB,kBAAA;AAiBnB;;AAdA;EAAuB,mBAAA;AAkBvB;;AAjBA;EACE,gBAAA;AAoBF;;AAlBA;EAAyC,gBAAA;AAsBzC;;AArBA;EAAgB,UAAA;AAyBhB;;AAxBA;EAAsB,aAAA;AA4BtB;;AA1BA;EACE,wBAAA;EACA,wBAAA;AA6BF;;AA1BA;EACE,aAAA;EACA,2BAAA;AA6BF;;AA1BA;EACE;IAAQ,iBAAA;EA8BR;EA1BA;IACE,eAAA;IACA,WAAA;IACA,SAAA;IACA,UAAA;EA4BF;EAzBA;IAAY,wBAAA;EA4BZ;EA3BA;IAAe,wBAAA;EA8Bf;EA5BA;IAAa,oCAAA;EA+Bb;EA7BA;IAAI,cAAA;EAgCJ;EA/BA;IAAS,eAAA;EAkCT;AACF;AAhCA;EACE;IACE,uBAAA;IACA,sBAAA;EAkCF;EA/BA;IACE,2BAAA;EAiCF;AACF","sourcesContent":["// All worksheet styles inherited from global print CSS.\n// Page-specific overrides:\n\n@page {\n  size: letter portrait;\n  margin: 0.25in;\n}\n\n:host {\n  display: block;\n  background: white;\n  min-height: 100vh;\n}\n\n.pdf-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  min-height: 52px;\n  padding: 8px 16px;\n  border-bottom: 1px solid #d6d6d6;\n  background: #f7f7f7;\n}\n\n.pdf-actions {\n  display: flex;\n  flex-shrink: 0;\n  gap: 8px;\n}\n\n.pdf-preview {\n  display: block;\n  width: 100%;\n  height: calc(100vh - 53px);\n  border: 0;\n  background: #525659;\n}\n\n.container.report {\n  box-sizing: border-box;\n  width: 8in;\n  max-width: 8in;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 30px;\n  font-family: sans-serif;\n  font-size: 10.5pt;\n}\n\n.title {\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n.caption-bold {\n  font-weight: bold;\n}\n\n.cell {\n  height: 1.5em;\n  overflow: hidden;\n\n  &.value {\n    text-align: center;\n    border-bottom: 1px solid black;\n  }\n}\n\n.row > .reading-label {\n  text-align: right;\n  padding-right: 6px;\n}\n\n.new-section {\n  margin-top: 10px;\n}\n\n.dark-pale {\n  background-color: #feffa4 !important;\n}\n\n.divider {\n  background-color: #cccccc !important;\n}\n\n.nobr { white-space: nowrap; }\n\n.width20    { width: 20px; }\n.width100px { width: 100px; }\n.width155   { width: 155px; }\n.width160px { width: 160px; }\n.width200px { width: 200px; }\n.width730px { width: 730px; }\n\ntable.wide { width: 730px; }\n\ntable.printable {\n  font-size: 10.5pt;\n  border-spacing: 0;\n  border-style: solid;\n  border-color: black;\n  border-collapse: collapse;\n  margin: 3px 0;\n  page-break-inside: avoid;\n\n  th, td {\n    border-width: 1px;\n    padding: 0 3px;\n    border-style: solid;\n    border-color: black;\n    page-break-inside: avoid;\n  }\n\n  th.text-center { text-align: center; }\n}\n\ntable.content-top td { vertical-align: top; }\ntable.worksheet-tables table.printable tr > :nth-child(2):not([colspan]) {\n  min-width: 150px;\n}\ntable.worksheet-tables table.naf-tests { margin-top: 20px; }\ntable caption { padding: 0; }\ntable caption:empty { display: none; }\n\ndiv.pagebreak {\n  page-break-after: always;\n  page-break-inside: avoid;\n}\n\nhr.hiddenprint {\n  margin: 8px 0;\n  border-top: 1px dashed #ccc;\n}\n\n@media print {\n  :host { background: white; }\n\n  // Use the full printable width so the fixed-width worksheet tables\n  // fit on the page instead of overflowing and being clipped.\n  .container.report {\n    max-width: 100%;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n  }\n\n  .no-print { display: none !important; }\n  .hiddenprint { display: none !important; }\n\n  .dark-pale { background-color: #feffa4 !important; }\n\n  * { font-size: 7pt; }\n  h4, h5 { font-size: 1rem; }\n}\n\n@media (max-width: 720px) {\n  .pdf-toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .pdf-preview {\n    height: calc(100vh - 105px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
